




























































































import Vue from "vue"
import request from '../lib/request'
import {StoryInfo, StoryUtils} from '../lib/story-utils'
import StoryGraph from './StoryGraph.vue'
import GrafanaGraph from './GrafanaGraph.vue'
import {RunnerInfo} from '../lib/runner-utils'
import ChooseRunner from './ChooseRunner.vue'
import StoryStatistics from './StoryStatistics.vue'
import bus from '../lib/bus'

let tabRouteMapping: { [key:string]: string } = {
  'overview': 'story',
  'fallback': 'story-fallback',
  'monitoring': 'story-statistics',
  'runners': 'story-runners'
}

export default Vue.extend({
  data() {
    return {
      storyName: this.$route.params.storyName,
      storyInfo: {} as StoryInfo,
      // currTab: 'overview',
      runners: <RunnerInfo[]>[],
      chooseRunner: false
    }
  },

  components: {
    StoryGraph,
    GrafanaGraph,
    ChooseRunner,
    StoryStatistics
  },

  created() {
    this.fetchData()
  },

  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData() {
      request.getStory(this.storyName)
        .then(storyInfo => {
          this.storyInfo = storyInfo
        })
      request.getStoryRunners(this.storyName)
        .then(infos => {
          this.runners = infos
        })
    },

    changeTab(tab: string) {
      let routeName = tabRouteMapping[tab]
      this.$router.push({ name: routeName, params: { storyName: this.storyName } })
      // this.currTab = tab
    },

    onSaveStory(newStoryInfo: StoryInfo) {
      request.updateStory(this.storyName, newStoryInfo)
        .then(() => {
          this.storyInfo = StoryUtils.copyStoryInfo(newStoryInfo)
          bus.$emit('notify', 'The story has been updated!')
        })
    },

    onOpenChooseRunner(): void {
      this.chooseRunner = true
    },
    onCloseChooseRunner(): void {
      this.chooseRunner = false
    },
    onAssignRunner(runnerInfo: RunnerInfo): void {
      let typpedAmount = prompt(`How many instances you want the runner "${runnerInfo.name}" to run?`, '1')
      // confirm(`Are you sure to assign story "${this.storyName}" to runner "${runnerInfo.name}"?`)
      if (typpedAmount != null && typpedAmount != "") {
        let amount = parseInt(typpedAmount)
        if (isNaN(amount) || amount <= 1) amount = 1
        runnerInfo.stories[this.storyName] = amount + ''
        request.assignStory(runnerInfo.name, this.storyName, amount)
          .then(() => {
            this.runners.push(runnerInfo)
            this.onCloseChooseRunner()
            bus.$emit('notify', `The story has been assigned to runner "${runnerInfo.name}"!`)
          })
      }
    },
    onDismissRunner(runnerInfo: RunnerInfo): void {
      if (confirm(`Are you sure to dismiss story "${this.storyName}" from runner "${runnerInfo.name}"?`)) {
        request.unassignStory(runnerInfo.name, this.storyName)
          .then(() => {
            let index = -1
            this.runners.forEach((info, _index) => {
              if (info.name == runnerInfo.name) {
                index = _index
                return;
              }
            })
            if (index !== -1) {
              this.runners.splice(index, 1)
            }
            bus.$emit('notify', `The story has been unassigned from runner "${runnerInfo.name}"!`)
          })
      }
    },
    onRerun(runnerInfo: RunnerInfo): void {
      if (confirm(`Are you sure to rerun story "${this.storyName}" on runner "${runnerInfo.name}"?`)) {
        request.rerunStory(runnerInfo.name, this.storyName)
          .then(() => {
            bus.$emit('notify', `The story has been rerun on runner "${runnerInfo.name}"!`)
          })
      }
    }
  },

  computed: {
    currTab(): string {
      for (let key in tabRouteMapping) {
        if (tabRouteMapping[key] == this.$route.name)
          return key;
      }
      return "overview";
    },
    isOverview(): boolean {
      return this.currTab == 'overview'
    },
    isFallback(): boolean {
      return this.currTab == 'fallback'
    },
    isMonitoring(): boolean {
      return this.currTab == 'monitoring'
    },
    isRunners(): boolean {
      return this.currTab == 'runners'
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Story.vue